export enum NutritionTable {
    AESTETHIC = 'estetica_nutrition',
    CUSTOM = 'p_customize_nutrition',
    HEALTH = 'salud_nutrition',
}